import { render, staticRenderFns } from "./SourceCostReport.vue?vue&type=template&id=5f22e655"
import script from "./SourceCostReport.vue?vue&type=script&lang=js"
export * from "./SourceCostReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports